























import { Component, Vue } from 'vue-property-decorator';
import tableListComponent from './components/table-list-component.vue';
import navComponent from './components/nav-component.vue';
import selectedItem from './components/selected-item.vue';
import { Icon } from './icon-interface';

@Component({
  components: {
    'table-list-component': tableListComponent,
    'nav-component': navComponent,
    'selected-item': selectedItem
  }
})
export default class App extends Vue {
  filter: string = '';
  icon: Icon | null = null;
}
